import { useErrorBoundary } from 'react-error-boundary'

export function useErrorHandler() {
    const { showBoundary: logAndDisplayError } = useErrorBoundary()
    return { logAndDisplayError }
}
